import { useEffect, useState } from "react";
import api from "../api/api";
import { useLocation } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function HotelSearch() {
    const [hotels, setHotels] = useState([]);
    const location = useLocation();
    const searchData = location.state;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);





    // Fetch hotels
    useEffect(() => {
        const fetchHotels = async () => {
            setLoading(true);
            setError(false);

            try {
                const res = await api.get("/hotels", {
                    params: {
                        destination: searchData?.destination
                    }
                });

                setHotels(res.data);
            } catch (err) {
                console.error(err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchHotels();
    }, [searchData]);

    return (
        <div>


            <PageHeader
                title="Available Hotels"
                subtitle={`${hotels.length} hotels found matching your search`}
            />

            <div className="bg-slate-50 dark:bg-gray-950 min-h-screen py-12">
                <div className="max-w-7xl mx-auto px-6">

                    <div className="text-center mb-12">
                        <span className="inline-block px-3 py-1 text-xs font-semibold bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 rounded-full mb-3">
                            Hotel Search
                        </span>

                        <h2 className="text-4xl font-bold text-slate-800 dark:text-white">
                            Available Hotels
                        </h2>

                        <p className="text-gray-500 dark:text-gray-400 mt-3">
                            Found {hotels.length} hotels matching your search
                        </p>
                    </div>

                    {loading ? (
                        <div className="flex flex-col items-center justify-center py-28 text-center">

                            <div className="relative w-24 h-24 mb-6">

                                <div className="absolute inset-0 rounded-full border-4 border-blue-100 dark:border-blue-900"></div>

                                <div className="absolute inset-0 rounded-full border-4 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>

                                <div className="absolute inset-0 flex items-center justify-center">
                                    <div className="w-10 h-10 bg-blue-500 rounded-lg animate-pulse"></div>
                                </div>

                            </div>

                            <h3 className="text-lg font-semibold text-gray-700 dark:text-white">
                                Searching the best hotels
                            </h3>

                            <p className="text-gray-500 dark:text-gray-400 mt-2">
                                Finding perfect stays for your destination...
                            </p>

                            <div className="flex gap-1 mt-4">
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></span>
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.1s]"></span>
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.2s]"></span>
                            </div>

                        </div>
                    ) : error ? (
                        <div className="text-center py-20">
                            <p className="text-red-500 text-lg">Something went wrong</p>
                        </div>

                    ) : hotels.length > 0 ? (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">

                            {hotels.map((hotel) => (
                                <div
                                    key={hotel.id}
                                    onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                    className="group bg-white dark:bg-gray-900 rounded-2xl overflow-hidden
    shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer
    border border-gray-100 dark:border-gray-800 hover:-translate-y-1"
                                >

                                    {/* Image */}
                                    <div className="relative h-52 overflow-hidden">

                                        <img
                                            src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                            alt={hotel.name}
                                            className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                                        />

                                        {/* Rating badge (ONLY REAL DATA) */}
                                        <div className="absolute top-3 right-3 bg-white/90 dark:bg-gray-800/90 backdrop-blur px-3 py-1 rounded-full text-xs font-semibold shadow">
                                            ⭐ {hotel.rating || "4.5"}
                                        </div>

                                        {/* Popular badge (conditional) */}
                                        {hotel.rating >= 4.5 && (
                                            <div className="absolute top-3 left-3 bg-green-600 text-white text-xs px-3 py-1 rounded-full font-semibold shadow">
                                                Popular Choice
                                            </div>
                                        )}

                                        {/* Soft overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                    </div>

                                    {/* Content */}
                                    <div className="p-4">

                                        {/* Title */}
                                        <h3 className="font-bold text-gray-800 dark:text-white text-lg line-clamp-1 group-hover:text-blue-600 transition">
                                            {hotel.name}
                                        </h3>

                                        {/* Location */}
                                        <p className="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1 mt-1">
                                            <FaMapMarkerAlt />
                                            {hotel.location || hotel.city || "Dubai, UAE"}
                                        </p>

                                        {/* Description */}
                                        <p className="text-sm text-gray-600 dark:text-gray-300 mt-3 line-clamp-2 min-h-[42px]">
                                            {hotel.short_description?.replace(/<[^>]*>/g, "")}
                                        </p>

                                        {/* Price + Button */}
                                        <div className="flex items-center justify-between mt-4">

                                            <div>
                                                <p className="text-blue-600 font-bold text-xl">
                                                    AED {Math.round(hotel.price_per_night)}
                                                </p>
                                                <span className="text-xs text-gray-400 dark:text-gray-500">
                                                    per night
                                                </span>
                                            </div>

                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/hotels/${hotel.slug}`);
                                                }}
                                                className="px-4 py-2 rounded-lg
                bg-gradient-to-r from-blue-500 to-cyan-500
                text-white text-sm font-medium
                shadow-md hover:shadow-xl
                transition-all duration-300
                hover:-translate-y-1 hover:scale-105 active:scale-95"
                                            >
                                                View Deal →
                                            </button>

                                        </div>

                                    </div>
                                </div>
                            ))}

                        </div>
                    ) : (
                        <p className="text-center text-gray-500 dark:text-gray-400 py-20">
                            No hotels found
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}